module.exports = __webpack_public_path__ + "media/review-badges/rank-empty-61eec063.svg";